

















































































































































































import {Component, Vue} from "vue-property-decorator";
import companyApi from "@/api/companyApi";
import QErrors from "@/common/qErrors.vue";
import Company, {COMPANY_ROLE} from "@/model/company";
import postalCodeApi from "@/api/postalCodeApi";
import qNotify from "@/common/qNotify";
import AccountCreate from "@/components/account/accountCreate.vue";
import store from "@/store";
import {namespace} from "vuex-class";
import User from "@/model/user";
import QCalendar from "@/common/qCalendar.vue";
import { LICENSES } from "@/common/constant";
import {compareWithKeys} from "@/common/utils";
import _ from "lodash";

const authStore = namespace("Auth");

@Component({
  name: "PartnerCreate",
  components: {
    QErrors,
    AccountCreate,
    QCalendar,
  },
})
export default class PartnerCreate extends Vue {
  @authStore.Getter
  public getCurrentyCompany!: Company;
  @authStore.Getter
  public isAdmin;

  public isShow = false;
  public partner :Company = new Company();
  public partnerInit :Company = new Company();
  public errors = {};

  get mcCompanyId() {
    return store.state.Company.mcCompanyId;
  }

  get isMcCompany() {
    return !!store.state.Company.mcCompanyId;
  }

  public show() {
    this.partner = new Company();
    if(this.isMcCompany) {
      this.partner.role_id = COMPANY_ROLE.WITNESS;
    } else {
      this.partner.role_id = COMPANY_ROLE.MANAGE;
    }

    this.errors = {};
    this.isShow = true;
    this.partnerInit = _.cloneDeep(this.partner)
  }

  public async getPostalCode() {
    if (this.partner.zip_code.trim() === '') {
      this.partner.address1 = "";
      this.errors = {};
      return;
    }

    const result = await postalCodeApi.show(this.partner.zip_code);
    if (result) {
      this.partner.address1 = result.prefecture + result.area + result.address;
      this.errors = {};
    } else {
      this.partner.address1 = "";
      this.errors = {
        zip_code: [this.$t("common.zip_code_not_found")],
      };
    }
  }

  public cancel() {
    if (this.isNotChangedPartner() === true) {
      this.isShow = false;
    } else {
      this.$modal.showCancel({
        text: this.$t("cancel"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.isShow = false;
        },
        onClose: () => {
          console.log("onClose");
        },
      });
    }
  }

  public async create() {
    const result = await companyApi.create(
      this.partner,
      this.isMcCompany ? this.mcCompanyId : null);
    if (result.meta.status != 200) {
      qNotify.error({
        text: this.$t("companies.created_fail"),
      });
      this.errors = result.meta.errors;
    } else {
      qNotify.success({
        text: this.$t("companies.created"),
      });

      const company = new Company(result.data);

      this.refreshList();
      this.isShow = false;
      this.showCreateAccount(company)
    }
  }

  public refreshList() {
    if(!this.isMcCompany || this.getCurrentyCompany) {
      this.$emit('refreshMcList');
    } else {
      this.refreshDetail()
    }

    this.isShow = false;
  }

  public async refreshDetail() {
    const result = await companyApi.getPartnerDetail(this.mcCompanyId);
    store.dispatch("Company/setCompany", new Company(result.data));
  }

  public showCreateAccount(company) {
    let user = new User();

    user.user_company.role_id = company.role_id;
    user.user_company.affiliation_company_id = company.id;

    if(this.isMcCompany) {
      user.user_company.company_id = this.mcCompanyId;
    } else if(this.getCurrentyCompany) {
      user.user_company.company_id = this.getCurrentyCompany.id;
    } else {
      user.user_company.company_id =  company.id;
    }

    (this.$refs.accCreate as AccountCreate).show(user);
  }

  get getLicenses() {
    return LICENSES;
  }

  public isDisplayAddLicense() {
    return this.isAdmin && !this.isMcCompany;
  }

  public isNotChangedPartner() {
    return (
      !compareWithKeys(this.partner, this.partnerInit, ['name','zip_code','address1','address2'])
      && (''+this.partner.role_id === ''+this.partnerInit.role_id)
      && (this.partner.company_licenses.length === this.partnerInit.company_licenses.length)
    );
  }
}
